import { render, staticRenderFns } from "./BirthCertificateModal.vue?vue&type=template&id=76e3f77a&scoped=true"
import script from "./BirthCertificateModal.vue?vue&type=script&lang=js"
export * from "./BirthCertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3f77a",
  null
  
)

export default component.exports